import { UserManager, WebStorageStateStore } from 'oidc-client';
import isEmpty from 'lodash/isEmpty';
import { SOTER_IDENTITY_CONFIG } from '../constants/Soter';
import LocaleService from '../services/localeService';

const userManager = new UserManager({
	...SOTER_IDENTITY_CONFIG,
	ui_locales: LocaleService.getOidcLocale(),
	userStore: new WebStorageStateStore({
		store: window.sessionStorage,
	}),
	automaticSilentRenew: true,
	filterProtocolClaims: true,
});

export function signinRedirect(returnPath) {
	if (typeof returnPath === 'string' && returnPath.startsWith('/')) {
		return userManager.signinRedirect({
			state: { returnPath },
		});
	}

	return userManager.signinRedirect();
}

export function signinRedirectCallback() {
	return userManager.signinRedirectCallback();
}

export function signoutRedirect() {
	return userManager.getUser().then((user) => {
		if (user) {
			const idToken = !isEmpty(user.id_token) ? user.id_token : '';
			return userManager.signoutRedirect({ id_token_hint: idToken });
		}

		return userManager.signoutRedirect();
	});
}

export function signoutRedirectCallback() {
	userManager.clearStaleState();
	userManager.removeUser();
	return userManager.signoutRedirectCallback();
}

export function signinSilent() {
	return userManager.signinSilent();
}

export function signinSilentCallback() {
	return userManager.signinSilentCallback();
}

export default userManager;
